export default __webpack_public_path__ + "static/media/icon_search_tag_program_black.11b55194.svg";